import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export interface ConfirmDialogProps {
  okFunction: () => void,
  cancelFunction: () => void,
  title: string,
  content: React.ReactNode,
  okButtonText: string,
  show: boolean
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = (props) => {
  const { okFunction, cancelFunction, title, content, okButtonText, show } = props;

  return (
    <Modal show={show} onHide={() => cancelFunction()}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {content}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => cancelFunction()}>
          Cancel
        </Button>
        <Button variant="primary" onClick={() => okFunction()}>
          {okButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}